module.exports = __webpack_public_path__ + "img/6.7e0083b5.png";